import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
} from "@mui/material";
import React, { FC } from "react";
import classNames from "classnames";
import { DialogBoxProps } from "components/types";
import useDialogBoxStyles from "./styles";
import Logo from "../../assets/Logo.svg";
import CloseIcon from "@mui/icons-material/Close";
import { DialogBoxEvent } from "types";

const DialogBox: FC<DialogBoxProps> = ({
  isModalOpen,
  handleModalClose,
  styles,
  width,
  height,
  closeIconStyles,
  content,
  showLogo,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const classes = useDialogBoxStyles();
  const handleClose = (_event: any, reason: string) => {
    if (reason !== DialogBoxEvent.BACKDROP) {
      handleModalClose();
    }
  };

  return (
    <Dialog
      open={isModalOpen}
      onClose={handleClose}
      PaperProps={{
        sx: {
          maxWidth: isMobile ? "auto" : "1100px",
          width: width ? width : "500px",
          height: height ? height : "auto",
          display: "flex-start",
        },
      }}
    >
      <DialogTitle className={classNames(classes.dialogTitle)} style={styles}>
        <Box className={classNames(classes.signupImage)}>
          {showLogo && <img src={Logo}></img>}
          <span
            className={classNames(classes.signupClose)}
            style={closeIconStyles}
            onClick={handleModalClose}
          >
            <CloseIcon />
          </span>
        </Box>
      </DialogTitle>
      <DialogContent
        className={classNames(classes.dialogContent)}
        style={styles}
      >
        {content}
      </DialogContent>
    </Dialog>
  );
};

DialogBox.defaultProps = {
  showLogo: true,
};

export default DialogBox;
